import { useUrlGenerator } from '@folklore/routes';
import { useTracking } from '@folklore/tracking';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

function useSetUser() {
    // const setUserBase = useSetUserBase();
    const queryClient = useQueryClient();
    const tracking = useTracking();
    const url = useUrlGenerator();
    const setUser = useCallback(
        (user) => {
            queryClient.setQueryData(['user'], user);
            tracking.setUser(user);
            queryClient.invalidateQueries({
                queryKey: ['page', url('account')],
            });
            queryClient.invalidateQueries({
                queryKey: ['page', url('profile')],
            });
        },
        [tracking],
    );
    return setUser;
}

export default useSetUser;
